import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import AosVue from "aos-vue";
import "./assets/tailwind.css";

createApp(App).use(store).use(AosVue).use(router).mount("#app");
